import { ErrorResponse, HttpMethod } from '@aibees/shared/definition';
import { authFetcher } from '@aibees/shared/http/fetcher';
import { toBase64BasicHeader } from '@aibees/shared/utils';
import { useMutation } from '@tanstack/react-query';
import {
  AUTH_CLIENT_ID,
  AUTH_REDIRECT_URL,
  AUTH_TOKEN_ENDPOINT,
} from '../constants';
import { GetTokenRequest, GetTokenResponse } from './types';

export function useGetToken() {
  return useMutation<GetTokenResponse, ErrorResponse, GetTokenRequest>(
    (data) => {
      // Always use base AUTH_REDIRECT_URL - must match what was sent to OAuth
      const redirect_uri = AUTH_REDIRECT_URL;

      return authFetcher({
        method: HttpMethod.post,
        url: AUTH_TOKEN_ENDPOINT,
        data: {
          code: data.code,
          grant_type: data.grant_type,
          redirect_uri,
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: toBase64BasicHeader(AUTH_CLIENT_ID),
        },
      });
    }
  );
}
